
<nav class="native-menu" *ngIf="isLargeScreen()">
  <ul>
    <li *ngFor="let item of items">
      <a (click)="GoTo(item)">
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
        <span *ngIf="item.items" class="pi pi-chevron-right"></span>
      </a>
      <ul *ngIf="item.items" [ngClass]="{ horizontal: item.horizontal }">
        <li *ngFor="let child of item.items" (mouseenter)="onSubmenuMouseEnter($event, !!child.items)">
          <a (click)="GoTo(child)">
            <i [class]="child.icon"></i>
            <span>{{ child.label }}</span>
            <span *ngIf="child.items" class="pi pi-chevron-right"></span>
          </a>
          <ul *ngIf="child.items" [ngClass]="{ horizontal: child.horizontal }">
            <li *ngFor="let subChild of child.items">
              <a (click)="GoTo(subChild)">
                <i [class]="subChild.icon"></i>
                <span>{{ subChild.label }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>

<p-panelMenu [model]="itemsMobile" *ngIf="!isLargeScreen()"></p-panelMenu>

<span class="versionStyle">V {{ version }}</span>
